import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"pencil\">\n    <path d=\"M15.211 0c-.697 0-1.356.347-1.905.893L1.905 12.275 0 18l5.704-1.906.12-.116L17.116 4.716c.544-.55.884-1.212.884-1.912s-.34-1.36-.884-1.911C16.567.347 15.91 0 15.211 0zm-2.816 3.79l1.817 1.83-9.266 9.245-2.723.91.911-2.74 9.261-9.244z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol